  <ng-container *transloco="let t">
    <p class="pb-2 fs-18 fw-medium">{{t('policy.intellectual.property.subtitle')}} {{environment.intelectual_property_validity_date | localizedDate:'dd.MM.yyyy'}}</p>
    <p>{{t('policy.intellectual.property.intro.1')}} <a href="">{{environment.appName}}</a>  {{t('policy.intellectual.property.intro.2')}}</p>

    <div class="chapter mt-3">
      <p class="fw-medium fs-28">
        {{t('policy.intellectual.property.chapter.1.title')}}
      </p>
      <p>{{t('policy.intellectual.property.chapter.1')}}
      </p>
    </div>

    <div class="chapter mt-3">
      <p class="fw-medium fs-28">
        {{t('policy.intellectual.property.chapter.2.title')}}
      </p>
      <p>{{t('policy.intellectual.property.chapter.2')}}
    </div>

    <div class="chapter mt-3">
      <p class="fw-medium fs-28">
        {{t('policy.intellectual.property.chapter.3.title')}}
      </p>
      <p>{{t('policy.intellectual.property.chapter.3.1')}}
      </p>
      <ul>
        <li> <p>{{t('policy.intellectual.property.chapter.3.2')}}</p></li>
        <li> <p>{{t('policy.intellectual.property.chapter.3.3')}}</p></li>
      </ul>
    </div>

    <div class="chapter mt-3">
      <p class="fw-medium fs-28">
        {{t('policy.intellectual.property.chapter.4.title')}}
      </p>
      <p>{{t('policy.intellectual.property.chapter.4')}}
        <a href="mailto: {{environment.contactMail}}">{{environment.contactMail}}</a>
      </p>
    </div>

    <div class="chapter mt-3">
      <p class="fw-medium fs-28">
        {{t('policy.intellectual.property.chapter.5.title')}}
      </p>
      <p>{{t('policy.intellectual.property.chapter.5')}}
      </p>
    </div>

    <div class="chapter mt-3">
      <p class="fw-medium fs-28">
        {{t('policy.intellectual.property.chapter.6.title')}}
      </p>
      <p>{{t('policy.intellectual.property.chapter.6')}}
      </p>
    </div>

    <div class="chapter mt-3">
      <p class="fw-medium fs-28">
        {{t('policy.intellectual.property.chapter.7.title')}}
      </p>
      <p>{{t('policy.intellectual.property.chapter.7')}}
        <a href="mailto: {{environment.contactMail}}">{{environment.contactMail}}</a>
      </p>

    </div>

  </ng-container>

